(()=>{
 let gallery,offer,header;
 function size(){
  if(!offer)return;
  offer.style.setProperty('--gallery-height',gallery.offsetHeight+'px');
  offer.style.setProperty('--header-height',(header?.offsetHeight||56)+'px');
  document.documentElement.style.setProperty('--purchase-header-height',(header?.offsetHeight||56)+'px');

 }
 function init(){
  const next=document.querySelector('#offers');if(!next||next===offer)return;
  offer=next;gallery=document.querySelector('#product .gallery');header=document.querySelector('.site-header');
  new ResizeObserver(size).observe(gallery);if(header)new ResizeObserver(size).observe(header);size();
 }
 new MutationObserver(init).observe(document.body,{childList:true,subtree:true});init();
 addEventListener('resize',size);
 const states = new WeakMap();
 document.addEventListener('click',event=>{
  const summary=event.target.closest('#offers .purchase-conditions > summary');
  if(!summary)return;
  event.preventDefault();
  const details=summary.parentElement,old=states.get(details);
  const opening=old ? !old.opening : !details.open;
  const start=details.getBoundingClientRect().height;
  if(old){old.animation.onfinish=null;old.animation.cancel();}
  details.style.height='';details.open=true;
  const target=opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height+parseFloat(getComputedStyle(details).borderTopWidth)+parseFloat(getComputedStyle(details).borderBottomWidth);
  if(matchMedia('(prefers-reduced-motion:reduce)').matches){details.open=opening;states.delete(details);return;}
  const animation=details.animate([{height:start+'px'},{height:target+'px'}],{duration:340,easing:'cubic-bezier(.25,.8,.25,1)',fill:'both'});
  states.set(details,{animation,opening});
  animation.onfinish=()=>{details.open=opening;animation.cancel();states.delete(details);};
 });
})();
